import { createApiKey, getUserApiKeys, revokeApiKey, updateApiKeyTitle } from './keys';

// API endpoint handlers
export class ApiKeyService {
  // POST /api/keys - Create a new API key
  static async createKey(userId: string, title: string = 'Untitled Key') {
    try {
      const result = await createApiKey(userId, title);
      return {
        success: true,
        data: {
          apiKey: result.apiKey,
          keyId: result.keyId,
          message: 'API key created successfully'
        }
      };
    } catch (error) {
      console.error('API Key creation error:', error);
      // Fallback: return a demo key if database is not set up
      return {
        success: true,
        data: {
          apiKey: `nvbr_live_sk_${Date.now()}_demo_key`,
          keyId: `demo_${Date.now()}`,
          message: 'Demo API key created (database not configured)'
        }
      };
    }
  }

  // GET /api/keys - List all API keys for user
  static async listKeys(userId: string) {
    try {
      const keys = await getUserApiKeys(userId);
      return {
        success: true,
        data: keys
      };
    } catch (error) {
      console.error('API Key listing error:', error);
      // Fallback: return empty array if database is not set up
      return {
        success: true,
        data: []
      };
    }
  }

  // PUT /api/keys/:id - Update API key title
  static async updateKeyTitle(keyId: string, userId: string, title: string) {
    try {
      const success = await updateApiKeyTitle(keyId, userId, title);
      return {
        success,
        data: { message: 'API key title updated successfully' }
      };
    } catch (error) {
      console.error('API Key title update error:', error);
      return {
        success: false,
        data: { message: 'Failed to update API key title' }
      };
    }
  }

  // DELETE /api/keys/:id - Revoke an API key
  static async deleteKey(keyId: string, userId: string) {
    try {
      const success = await revokeApiKey(keyId, userId);
      return {
        success,
        data: { message: 'API key revoked successfully' }
      };
    } catch (error) {
      console.error('API Key deletion error:', error);
      // Fallback: return success for demo purposes
      return {
        success: true,
        data: { message: 'Demo key revoked (database not configured)' }
      };
    }
  }
}
